export {};

declare global {
    interface URL {
        updateQueryParam(params): URL
    }

}

if (!URL.prototype.updateQueryParam) {  
    URL.prototype.updateQueryParam = function (params): URL {
        Object.keys(params).forEach(key => {
            this.searchParams.delete(key);
            if(params[key]) this.searchParams.set(key, params[key]);
        })
        return this;
    }
}
